import React from "react";
import { useTranslation } from "react-i18next";
import { View, TouchableOpacity, StyleSheet, ScrollView, Platform } from "react-native";
import { Text } from "react-native-paper";
import { useThemeSettings } from "../../../ThemeProvider";
import CustomLinearGradient, { GRADIENT_TYPE } from "../../../components/CustomLinearGradient";
import getGlobalStyles from "../../../globalStyles";
import { FULL_WIDTH } from "../../../shared/constants/dimension";

const ShareLookPicker = ({ selected, onSelect }) => {
  const { t } = useTranslation();
  const { theme } = useThemeSettings();
  const gStyles = getGlobalStyles();
  return (
    <View style={{ marginBottom: 10 }}>
      <Text style={{ color: theme?.colors?.primary, marginBottom: 10, fontSize: 16 }}>
        {t("screens.share.pickYourLook")}
      </Text>

      <View style={[gStyles.centerRow, { width: FULL_WIDTH, justifyContent: 'space-evenly', gap: 12 }]}>
        {[GRADIENT_TYPE.CARD1, GRADIENT_TYPE.CARD2, GRADIENT_TYPE.CARD3].map((look) => (
          <TouchableOpacity
            key={look}
            onPress={() => onSelect(look)}
            style={{ flex: 1 }} >
            <CustomLinearGradient style={[selected === look && { borderWidth: 2, borderColor: theme?.colors?.primary }, { height: 35, borderRadius: 12 }]} gradientType={look} angle={180} />
          </TouchableOpacity>
        ))}
      </View>
    </View>
  );
};

export default ShareLookPicker;